// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__KOZzS {
  padding: 12px 32px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
}
@media (max-width: 992px) {
  .styles_wrapper__KOZzS {
    width: calc(100% - 158px);
    padding: 12px 9px 12px 32px;
    justify-content: flex-end;
  }
}

.styles_walletId__OnsNZ {
  max-width: 156px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.9);
  text-overflow: ellipsis;
  overflow: hidden;
}
.styles_walletId__OnsNZ:hover {
  max-width: 100%;
}
@media (max-width: 992px) {
  .styles_walletId__OnsNZ {
    max-width: 100%;
  }
}

.styles_iconsWrapper__8ZYwx {
  display: flex;
  align-items: center;
  gap: 12px;
}

.styles_icon__62GZx:hover path {
  stroke: #ff136d;
}`, "",{"version":3,"sources":["webpack://./src/components/wallet/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BCSS;EDRT,mBAAA;AAFF;AEkBE;EFtBF;IASI,yBAAA;IACA,2BAAA;IACA,yBAAA;EADF;AACF;;AAIA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BChBS;EDiBT,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,eAAA;AADJ;AEJE;EFPF;IAgBI,eAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAKE;EACE,eCpCG;ADkCP","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  padding: 12px 32px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: $black-30;\n  border-radius: 16px;\n\n  @include lg {\n    width: calc(100% - 158px);\n    padding: 12px 9px 12px 32px;\n    justify-content: flex-end;\n  }\n}\n\n.walletId {\n  max-width: 156px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-90;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &:hover {\n    max-width: 100%;\n  }\n\n  @include lg {\n    max-width: 100%;\n  }\n}\n\n.iconsWrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.icon {\n  &:hover path {\n    stroke: $pink;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__KOZzS`,
	"walletId": `styles_walletId__OnsNZ`,
	"iconsWrapper": `styles_iconsWrapper__8ZYwx`,
	"icon": `styles_icon__62GZx`
};
export default ___CSS_LOADER_EXPORT___;
